import { Fragment, useState, useContext, useEffect } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import SideBar from "../sidebar/SideBar";
import { menuContext } from "../../context/menucontext";
import LoaderCard from "../../components/loaderCard/LoaderCard";

const PageLayout = ({ children, theme }) => {
  const { menuStatus, setMenuStatus } = useContext(menuContext);

  const [loader, setLoader] = useState(false);

  useEffect(() => {
  const intervalId =  setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 2000);


    return () => {
      clearInterval(intervalId);
    };


  }, []);

  return (
    <Fragment>
      <Header scrolltheme={theme} />
      {loader ? (
        <LoaderCard />
      ) : (
        <Fragment>
          <SideBar />
          {children}
        </Fragment>
      )}

      <Footer />
    </Fragment>
  );
};

export default PageLayout;
